import { getSignedUrlByFileId } from './files/uploadFile';

export function downloadFileFromLink(fileUrl: string, fileName: string) {
  fetch(fileUrl)
    .then((response) => response.blob())
    .then((blob) => {
      const tempLink = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      tempLink.href = objectUrl;
      tempLink.setAttribute('download', fileName);
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      URL.revokeObjectURL(objectUrl);
    })
    .catch((error) => console.error('Error downloading the file:', error));
}

export async function downloadFileFromFileId(fileId: number, fileName: string) {
  const url = await getSignedUrlByFileId(fileId, undefined);
  if (url) {
    downloadFileFromLink(url, fileName);
  }
}
